import { useAppSelector } from "@store/store-helper";
import { userStateSelector } from "@store/user/user-slice";
import { PermissionKey } from "@utils/permissions/permission-matrix";
import {
  getDeniedReason,
  hasPermission,
} from "@utils/permissions/permissions-utils";

interface ReturnProps {
  /** Whether the logged in user has a role that grants the permission */
  isAllowed: boolean;

  /** Why the action is unavailable, or undefined when it is allowed */
  deniedReason?: string;
}

/**
 * Checks if the logged in user may do the action behind the permission.
 * Reads the roles from the store only, so it never triggers a fetch.
 */
export function usePermission(permission: PermissionKey): ReturnProps {
  const { currentUserRoles } = useAppSelector(userStateSelector);
  const isAllowed = hasPermission(currentUserRoles, permission);

  return {
    isAllowed,
    deniedReason: isAllowed ? undefined : getDeniedReason(permission),
  };
}
